<div class="reposicion-menu">
  <ng-container *ngFor="let item of menuItems; let last = last">
    <button
      class="menu-btn"
      [routerLink]="item.disabled ? null : [item.route]"
      routerLinkActive="btn-active"
      [disabled]="item.disabled"
    >
      <span class="step">{{ item.step }}</span>
      <span class="label">{{ item.label }}</span>
      <i [class]="item.icon + ' menu-icon'"></i>
    </button>

    <span class="menu-arrow" *ngIf="!last">
      <i class="pi pi-angle-right"></i>
    </span>
  </ng-container>
</div>
